export default __webpack_public_path__ + "static/media/08.aa78673e.mp3";